// What each player did over a game, for their stats: the leaders they put into play, the wonders they completed, the
// technologies they developed and the governments they took, in order, and the most buildings or units of each kind
// they had at once (an arena counts once it has a worker on it); and the events they prepared, in order (Confucius's
// non-events only counted: which cards they were is never told). Noted after every move (Authority.Commit), so a game
// replayed from its moves gets it back as it was. Who prepared which event is secret until the game is over (see
// Authority.ViewFor).
const TechnologyTypes = require('../Constants/TechnologyTypes');
const { MilitaryCardTypes } = require('../Constants/Names/CardTypes');

// The kinds counted for the peak: buildings and units (worker counts on the technologies of that type)
const Counted = [...Object.values(TechnologyTypes.Production), ...Object.values(TechnologyTypes.Urban), ...Object.values(TechnologyTypes.Military)];

class Career
{
    constructor(gameState)
    {
        // The starting technologies are not developed: they are there from the start
        this.players = gameState.playerStates.map(player => ({
            leaders: [],
            wonders: [],
            technologies: [],
            governments: [],
            peak: Object.fromEntries(Counted.map(type => [type, 0])),
            colonies: 0,
            // Events and territories prepared ({ type, name, age }), and how many other cards (Confucius)
            prepared: [],
            nonEvents: 0,
            known: { leader: null, wonders: new Set(), technologies: new Set(player.technologies.map(tech => tech.name)), government: player.government },
        }));
        this.Note(gameState);
        // (what they started with, to tell what they built from what they were given)
        this.players.forEach(career => { career.start = { ...career.peak }; });
    }

    Note(gameState)
    {
        gameState.playerStates.forEach((player, index) => {
            const career = this.players[index];
            const leader = player.leader?.name ?? null;
            if (leader && leader !== career.known.leader)
            {
                career.leaders.push(leader);
            }
            career.known.leader = leader;
            player.wonders.forEach(wonder => {
                if (!career.known.wonders.has(wonder.name))
                {
                    career.known.wonders.add(wonder.name);
                    career.wonders.push(wonder.name);
                }
            });
            player.technologies.forEach(tech => {
                if (!career.known.technologies.has(tech.name))
                {
                    career.known.technologies.add(tech.name);
                    career.technologies.push(tech.name);
                }
            });
            if (player.government !== career.known.government)
            {
                career.known.government = player.government;
                career.governments.push(player.government);
            }
            Counted.forEach(type => {
                const count = player.technologies.filter(tech => tech.type === type).reduce((sum, tech) => sum + tech.GetWorkerCount(), 0);
                career.peak[type] = Math.max(career.peak[type], count);
            });
            career.colonies = Math.max(career.colonies, player.colonies?.length ?? 0);
        });
    }

    // A player prepared this military card as an event
    NotePrepared(playerNumber, card)
    {
        const career = this.players[playerNumber];
        if (card.type === MilitaryCardTypes.Event || card.type === MilitaryCardTypes.Territory)
        {
            career.prepared.push({ type: card.type, name: card.name, age: card.age });
        } else {
            career.nonEvents++;
        }
    }

    // Each player's, as plain data
    Summary()
    {
        return this.players.map(({ known, ...career }) => ({ ...career, peak: { ...career.peak }, start: { ...career.start },
            prepared: career.prepared.map(card => ({ ...card })) }));
    }
}

module.exports = Career;
